export default __webpack_public_path__ + "static/media/infoIcon.68f2754c.svg";